const LayoutMonitorMain = () => import(/* webpackChunkName: "group-callcenter-monitor" */ '../_views/LayoutMonitorMain')

import { permissionsMonitorFilas } from '../../../utils/permissionsCallCenter'

export default [
  {
    path: 'monitor-filas',
    component: LayoutMonitorMain,
    meta: { requiresAuth: true, permissions: [...permissionsMonitorFilas] },
    name: 'MonitorCallCenter',
  },
]
